import React, {useEffect, useState} from 'react'
import {KeyboardArrowLeft, KeyboardArrowDown} from "@mui/icons-material";


export default function ChallengeDetails(props) {

    const truncateDescription = (str, n) => {
        // return (str.length > n) ? str.slice(0, n - 1) + '...' : str;

        let trimmedString = str.slice(0, n-1);
        trimmedString = str.slice(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
        return (str.length > n) ? trimmedString + ' ...' : str;

    }

    const shouldShowCarat = (str, n) => {
        try {
          return str.length >= n
        } catch (e) {
          return false;
        }
    }

    const truncateLength = 50

    const [result, setResult] = useState(shouldShowCarat(props.description, truncateLength) ? truncateDescription(props.description, truncateLength) : props.description)
    const showCarat = shouldShowCarat(props.description, truncateLength)
    const [caratDown, setCaratDown] = useState(false)


    const toggleCarat = () => {
        if (caratDown) {
            setResult(truncateDescription(props.description, truncateLength))
        }else{
            setResult(props.description)
        }
        setCaratDown(!caratDown)

    }

    useEffect(() => {


    }, [])


    return (
        <div className="challenge-details">
            <div onClick={toggleCarat} className="challenge-by-username">
                Challenge by {props.challengerUsername}
                {showCarat && caratDown === false &&
                    <span className="description-carat hand-hover"><KeyboardArrowLeft fontSize="medium"/></span>
                }
                {showCarat && caratDown &&
                    <span className="description-carat hand-hover"><KeyboardArrowDown fontSize="medium"/></span>
                }
            </div>
            <div onClick={toggleCarat} className={"challenge-description-text" + (showCarat ? " hand-hover" : "")}>{result}</div>
            <div className="pitch-user-label">
                <div className="pitch-user-label-avatar">
                    <img src={props.sharerOrganisationAvatar} alt="User's Club Avatar"/>
                </div>
                <div className="pitch-user-label-handle">
                    <strong>@{props.sharerUsername}</strong><br/>
                    <div>
                        <span className="pitch-sharer-position">{props.sharerPosition}</span> <img height="12px" src={props.sharerFlag} alt="Sharers Flag"/>
                    </div>
                </div>
            </div>

        </div>
    )


}